<template lang="pug">
span
  .md-layout
    .md-layout-item.ml-auto
      md-button.md-warning(
        style='float: right;'
        @click='filterDialog = true')
        v-icon(style='color: black !important; padding-right: 4px;') mdi-filter-variant
        span(style='color: black')
          | {{$t('eventAuthHistory.filter')}}
  .md-layout
    .md-layout-item.md-size-100.mx-auto(style='padding: 0')
      EventAuthTable(ref='chat-table-reference')
  GlobalDialog(
    v-model='filterDialog'
    max-width='700px'
    scrollable
    :headerTitle="$t('eventAuthHistory.filter')"
    showMButton
    mButtonTextColor='#FE544F'
    mButtonColor='#FE544F'
    mButtonIsOutlined
    :mButtonTitle="$t('eventAuthHistory.reset')"
    @clickMButton='resetFilter()'
    showRButton
    :rButtonTitle="$t('eventAuthHistory.toApply')"
    @clickRButton='saveFilter()')
    template(v-slot:content)
      EventAuthHistoryFilter(:key='resetKey')
</div>
</template>

<script>
import EventAuthTable from '@/components/EventAuthTable'
import GlobalDialog from '@/components/Reuse/GlobalDialog'
import EventAuthHistoryFilter from '@/components/Filters/EventAuthHistoryFilter'
import { mapFields } from 'vuex-map-fields'

export default {
  components: {
    EventAuthTable,
    GlobalDialog,
    EventAuthHistoryFilter
  },
  computed: {
    ...mapFields('eventAuthHistoryFilter', ['searchBarText', 'dateIntervalFilter', 'protocol', 'user_name', 'cpf', 'group_name', 'operator_name', 'operator_login', 'channelFilter', 'authenticated_type', 'user'])
  },
  data () {
    return {
      filterDialog: false,
      createButton: require('@/../public/img/plus.png'),
      resetKey: 0
    }
  },
  methods: {
    saveFilter () {
      this.filterDialog = false
      this.$refs['chat-table-reference'].changeFilters()
    },
    resetFilter () {
      this.searchBarText = undefined
      this.protocol = undefined
      this.user_name = undefined
      this.cpf = undefined
      this.channelFilter = undefined
      this.operator_name = undefined
      this.group_name = undefined
      this.operator_login = undefined
      this.authenticated_type = undefined
      this.user = undefined
      this.start_datetime = undefined
      this.end_datetime = undefined
      this.resetKey++

      this.saveFilter()
    }
  }
}
</script>
